/*code reference from @material_ui component Dialog https://material-ui.com/components/dialogs/*/

import React from "react";
import TextTheme from "components/General/Text/TextTheme";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import { withStyles } from '@material-ui/core/styles';
import MuiDialog from '@material-ui/core/Dialog';
import FileUpload from "../../../../site_media/images/File_Upload.png";
import CreationSuite from "../../../../site_media/images/paintbrush.png";
import Close from "../../../../site_media/images/icons8-close-window-24.png";

const CustomDialog = withStyles((theme) => ({
    paper: {
        borderRadius: "10px",
        maxHeight:'217px',
        maxWidth:'470px'
    },
}))(MuiDialog);

function CustomImagePopup(props) {
    return (
        <div>
            <CustomDialog
                open={true}
                onClose={() => (props.closePopUp())}
            >
                <DialogTitle>
                    <img className="upload-popup-close" src={Close} alt={"X"} onClick={()=>(props.closePopUp())} style={{cursor:'pointer'}} />
                </DialogTitle>
                <DialogContent>
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-around',marginTop:'7px'}} >
                        {props.count ===1?
                        <>
                                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                    <img src={CreationSuite} alt=''
                                        style={{
                                            width: "60px",
                                            cursor: 'pointer',
                                            marginBottom: '5.5px'
                                        }}
                                        onClick={props.openCreationSuite}></img>
                                    <TextTheme
                                        className="text_bold text_small text_dark_blue"
                                        message="Go to My Drafts"
                                    />
                                </div>
                        </>:
                        <>
                                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                    <img src={CreationSuite} alt=''
                                        style={{
                                            width: "60px",
                                            cursor: 'pointer',
                                            marginBottom: '5.5px'
                                        }}
                                        onClick={props.uploadApi}></img>
                                    <TextTheme
                                        className="text_bold text_small text_dark_blue"
                                        message="Open Creator Studio"
                                    />
                                </div>
                        </>}
											
                        <div style={{display:'flex',flexDirection:'column',alignItems:'center'}}>
                            {
                                props.count === 1?
                                <>
                                
                                <label >
                            <img src={FileUpload} alt=''
                                style={{
                                    width: "60px",
                                    cursor: 'pointer',
                                }}
                                >
                                </img>
                            <input
                                id="post_file"
                                type="file"
                                name="post_picture"
                                onChange={props.handleImageChange}
                                style={{ display: "none" }}
                            />
                            </label>
                            <TextTheme
                                className="text_bold text_small text_dark_blue"
                                message="Upload New Media"
                            />
                                    </>:
                                    <>
                                        <label >
                                            <img src={FileUpload} alt=''
                                                style={{
                                                    width: "60px",
                                                    cursor: 'pointer',
                                                }}
                                                onClick = {()=>(props.fileUpload())}
                                            >
                                            </img>
                                        </label>
                                        <TextTheme
                                            className="text_bold text_small text_dark_blue"
                                            message="Complete Upload"
                                        />
                                    </>
                            }
                            
                        </div>
                    </div>
                </DialogContent>

                <DialogActions>

                </DialogActions>
            </CustomDialog>
        </div>
    );

}

export default CustomImagePopup;